import React, { Component, ErrorInfo, ReactNode } from "react";
import ErrorFallbackView from "./ErrorFallbackView";

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  isRetrying: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    isRetrying: false,
  };

  static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Unhandled UI error:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ isRetrying: true }, () => {
      window.setTimeout(() => {
        this.setState({ hasError: false, isRetrying: false });
        window.location.reload();
      }, 250);
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallbackView
          loading={this.state.isRetrying}
          onRetry={this.handleRetry}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
